/**
 * @generated SignedSource<<0ff95ef11716a03aed26a137fb55eb63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateEmailTemplateVariantInput = {
  htmlContent: string;
  id: string;
  language: string;
  preheader?: string | null | undefined;
  subject: string;
  textContent: string;
};
export type EmailTemplateVariantPanelUpdateMutation$variables = {
  input: UpdateEmailTemplateVariantInput;
};
export type EmailTemplateVariantPanelUpdateMutation$data = {
  readonly updateEmailTemplateVariant: {
    readonly id: string;
    readonly updatedAt: any;
    readonly variants: ReadonlyArray<{
      readonly htmlContent: string | null | undefined;
      readonly language: string;
      readonly preheader: string | null | undefined;
      readonly subject: string | null | undefined;
      readonly textContent: string | null | undefined;
    }>;
  };
};
export type EmailTemplateVariantPanelUpdateMutation = {
  response: EmailTemplateVariantPanelUpdateMutation$data;
  variables: EmailTemplateVariantPanelUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailTemplate",
    "kind": "LinkedField",
    "name": "updateEmailTemplateVariant",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailTemplateVariant",
        "kind": "LinkedField",
        "name": "variants",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "preheader",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "htmlContent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "textContent",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailTemplateVariantPanelUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailTemplateVariantPanelUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ff51474643e64d8f41a90a705e3bf126",
    "id": null,
    "metadata": {},
    "name": "EmailTemplateVariantPanelUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation EmailTemplateVariantPanelUpdateMutation(\n  $input: UpdateEmailTemplateVariantInput!\n) {\n  updateEmailTemplateVariant(input: $input) {\n    id\n    variants {\n      language\n      subject\n      preheader\n      htmlContent\n      textContent\n    }\n    updatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "368e82724f68a35e5106557c1eb8ae2a";

export default node;
